import type { RouteConfig } from '@/types/route'

export interface BreadcrumbItem {
  path: string
  label: string
}

export const findRouteChain = (
  routes: RouteConfig[],
  pathname: string,
  parentPath = '',
  matched: RouteConfig[] = []
): RouteConfig[] | null => {
  for (const route of routes) {
    let fullPath = route.path
    if (parentPath) {
      fullPath = `${parentPath}/${route.path}`.replace(/\/+/g, '/')
    }
    if (!fullPath.startsWith('/') && fullPath !== '') {
      fullPath = `/${fullPath}`
    }

    if (fullPath === pathname) {
      return [...matched, route]
    }

    if (pathname.startsWith(fullPath + '/') && route.children) {
      const result = findRouteChain(route.children, pathname, fullPath, [...matched, route])
      if (result) {
        return result
      }
    }
  }

  return null
}

export const buildBreadcrumbs = (routeChain: RouteConfig[], homeLabel: string, isEnUS: boolean): BreadcrumbItem[] => {
  const breadcrumbs: BreadcrumbItem[] = []

  let currentPath = ''
  for (const route of routeChain) {
    currentPath = currentPath
      ? `${currentPath}/${route.path}`.replace(/\/+/g, '/')
      : route.path
    if (currentPath !== '' && !currentPath.startsWith('/')) {
      currentPath = `/${currentPath}`
    }

    const getRouteTitle = () => {
      if (isEnUS && route.titleEn) {
        return route.titleEn
      }
      return route.title || ''
    }

    if (currentPath === '/') {
      breadcrumbs.push({ path: '/', label: getRouteTitle() || homeLabel })
      continue
    }

    if (route.title) {
      breadcrumbs.push({
        path: currentPath,
        label: getRouteTitle(),
      })
    }
  }

  return breadcrumbs
}
